module.exports = __webpack_public_path__ + "static/media/google_cert1.5f50ddb9.png";